<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="user.role.roleName != 'ADMIN'"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    prepend-icon="event"
                    v-model="issueDate"
                    :readonly="user.role.roleName != 'ADMIN'"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="activeWarehouseList"
                  v-model="stockTake.warehouseId"
                  label="Choose Warehouse..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.warehouseRules"
                  :readonly="
                    user.warehouseId ||
                    user.roleName == 'PRODUCTION_MANAGER' ||
                    user.role.roleName == 'ASSET_MANAGER'
                      ? true
                      : false
                  "
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear"
                    >Reset<v-icon right>clear</v-icon></v-btn
                  >
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading"
                    @click="onSave"
                    >Save<v-icon right>save</v-icon></v-btn
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { stockTakeService } from "../../services/stock-take-service";
import { warehouseService } from "../../services/warehouse-service";
import { StockTake } from "../../models/model";
import { commonService } from "../../services/common-service";
import { StockTakeFormRules } from "../../helpers/validation-rules";

export default {
  name: "StockTakeRegister",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      { text: "Stock Take", disabled: false, to: "stock-takes" },
      { text: "Stock Take Detail", disabled: true },
    ],
    stockTake: new StockTake(),
    rules: new StockTakeFormRules(),
    activeWarehouseList: [],
    responseError: "",
    issueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
  }),
  created() {
    this.getActiveWarehouseList();
    if (this.user.warehouseId) {
      this.stockTake.warehouseId = this.user.warehouseId;
    }
    if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.stockTake.warehouseId = this.user.shop.warehouseId;
    }
  },
  methods: {
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.push("/stock-takes");
    },
    clear() {
      this.$refs.form.resetValidation();
      this.stockTake = new StockTake();
      if (this.user.warehouseId) {
        this.stockTake.warehouseId = this.user.warehouseId;
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.stockTake.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );
        stockTakeService
          .saveStockTake(this.stockTake)
          .then((res) => {
            if (res.data) {
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
  },
};
</script>
